import React from 'react';
import ReactDOM from 'react-dom';
import { asyncWithLDProvider, basicLogger } from 'launchdarkly-react-client-sdk';
import SessionReplay from '@launchdarkly/session-replay';
import './index.css';
import App from './App';

const VALID_KEY_REG_EX = /^[0-9a-fA-F]{24}$/;

const ANONYMOUS_ID_STORAGE_KEY = 'ld_anonymous_id';
const UUID_REG_EX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

// Helper to get or create a persistent anonymous ID so LD can attribute
// pre-login events to a stable user context.
const getAnonymousId = () => {
	const stored = localStorage.getItem(ANONYMOUS_ID_STORAGE_KEY);
	if (stored && UUID_REG_EX.test(stored)) {
		return stored;
	}

	const id = crypto.randomUUID();
	localStorage.setItem(ANONYMOUS_ID_STORAGE_KEY, id);
	return id;
};

void (async () => {
	const ldClientId = window.config.LD_CLIENT_ID;

	if (!ldClientId || !VALID_KEY_REG_EX.test(ldClientId)) {
		ReactDOM.render(
			<App />,
			document.getElementById('root'),
		);

		return;
	}

	const LDProvider = await asyncWithLDProvider({
		clientSideID: ldClientId,
		context: {
			kind: 'user',
			key: getAnonymousId(),
			anonymous: true,
		},
		options: {
			logger: basicLogger({ level: 'error' }),
			application: {
				id: 'ssmUi',
			},
			plugins: [
				new SessionReplay({
					privacySetting: 'strict',
				}),
			],
		},
	});

	ReactDOM.render(
		<React.StrictMode>
			<LDProvider>
				<App />
			</LDProvider>
		</React.StrictMode>,
		document.getElementById('root'),
	);
})();
